import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Motion from '@/components/base/motion'
import ProductCard from '@/components/base/product-card'

import { productsGridRevealAnimation } from './animations'
import { WPImage, WPLink } from '@/types'

export type ProductsGridProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    title: string
    subtitle: string
    paragraph: string
    alignment: 'left' | 'right'
    items: {
      icon: WPImage
      color: string
      title: string
      paragraph: string
      link: WPLink
    }[]
  }>

const GridCard = ({ items, ...props }: ProductsGridProps) => {
  return (
    <section {...props}>
      <Motion animation={productsGridRevealAnimation}>
        {(motionRef) => (
          <Container ref={motionRef}>
            <Grid className="items-center gap-y-spacing-lg">
              <div className="col-span-2 md:col-span-6 lg:col-span-12">
                <div className="grid grid-cols-2 gap-spacing-xs md:grid-cols-3">
                  {items?.map((item, index) => (
                    <div
                      key={`product-card-${index}`}
                      className="col-span-2 md:col-span-1"
                    >
                      <ProductCard
                        icon={item.icon}
                        color={item.color}
                        title={item.title}
                        paragraph={item.paragraph}
                        link={item.link}
                        data-motion-card
                      />
                    </div>
                  ))}
                </div>
              </div>
            </Grid>
          </Container>
        )}
      </Motion>
    </section>
  )
}

export default GridCard
